<template>
  <div style="padding:20px;">
    <div class="closeCurrntPage" @click="closeCurrntPage">X关闭当前页</div>
    <div flex="main:justify cross:center" class="gap-bottom">
      <div></div>
      <div>
        <upload-excel-component
          :on-success="importExcel"
          ref="uploadExcel"
          style="display:inline-block;z-index:-999999;top:-999999999px;position:fixed;"
          >导入</upload-excel-component
        >
        <el-tooltip
          class="item"
          effect="light"
          content="导出格式不能修改；仅物流承运商、物流运单号支持维护"
          placement="bottom"
        >
          <el-dropdown
            trigger="click"
            size="medium"
            placement="bottom"
            class="batchbtn"
            @command="handleCommand"
          >
            <el-button type="primary" size="small">
              批量录入
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="b">导出表格</el-dropdown-item>
              <el-dropdown-item command="a">导入表格</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-tooltip>
      </div>
    </div>
    <div class="table">
      <el-table
        :row-class-name="tableRowClassName"
        border
        v-loading="loading"
        :data="tableData"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column
          prop="created_at"
          label="推送日期"
          width="125"
        ></el-table-column>
        <el-table-column
          prop="main_number"
          label="主订单号"
          width="125"
        ></el-table-column>
        <el-table-column prop="serial_number" label="编号" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.serial_number">
              {{
                scope.row.serial_number
                  .split("-")
                  .slice(3)
                  .join("-")
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="box_num"
          label="打包箱数"
          width="60"
          v-if="!isFactory"
        ></el-table-column>
        <el-table-column
          prop="user_name"
          label="客户姓名"
          width="60"
        ></el-table-column>
        <el-table-column
          prop="mobile"
          label="客户电话"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="address"
          label="客户地址"
          width="120"
        ></el-table-column>
        <!-- <el-table-column prop="courierName" label="物流承运商" width="145"> -->
        <el-table-column prop="courier_code" label="物流承运商" width="145">
          <template slot="header" slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              content="按照选项[物流承运商]录入。若需录入的物流承运商在档案中没有，请提供给系统管理员维护。"
              placement="bottom"
            >
              <span class="el-icon-question">物流承运商</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <!-- :value="scope.row.courierName" -->
            <el-select
              :value="scope.row.courierName"
              size="mini"
              filterable
              :filter-method="filterMethod"
              @change="e => handleChangeCourier(e, scope)"
              clearable
              @clear="setTsListShort"
            >
              <el-option
                v-for="item in tsListShort"
                :label="item.provider_name"
                :value="item.provider_code + ''"
                :key="item.provider_code"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="courier_number" label="物流运单号">
          <template slot="header" slot-scope="scope">
            <el-tooltip class="item" effect="light" placement="bottom">
              <div slot="content">
                <div>a.将单元格格式设置为文本；</div>
                <div>
                  b.若一个单据存在多个运单号，请用半角英文状态下的逗号“,”隔开。
                </div>
              </div>
              <span class="el-icon-question">物流运单号</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              <el-input
                type="textarea"
                :autosize="{ minRows: 1, maxRows: 10 }"
                placeholder="多个运单号，请用英文逗号“,”隔开"
                v-model.trim="scope.row.courier_number"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="courier_mobile" label="物流联系电话">
          <template slot="header" slot-scope="scope">
            <el-tooltip class="item" effect="light" placement="bottom">
              <div slot="content">
                <div>将单元格格式设置为文本</div>
              </div>
              <span class="el-icon-question">物流联系电话</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              <el-input
                placeholder="请填写物流联系电话"
                size="small"
                v-model="scope.row.courier_mobile"
              ></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div flex="main:start" class="count-wrap">
      <div>合计</div>
      <div>主订单数量：{{ mainNumberCount }}</div>
      <div v-if="!isFactory">打包箱数：{{ boxNumberCount }}</div>
      <div v-if="!isFactory">单号数：{{ tsNumberCount }}</div>
    </div>
    <div flex="main:center" class="gap-top">
      <el-button type="primary" size="mini" @click="saveHandler"
        >保存</el-button
      >
    </div>
    <el-dialog
      title="确认"
      :visible.sync="dialogVisible"
      center
      append-to-body
      width="500px"
    >
      <div style="text-align:center;">
        <el-row
          type="flex"
          justify="center"
          align="middle"
          style="margin-bottom: 20px;"
        >
          <el-col :span="8"><div>类型</div></el-col>
          <el-col :span="12">
            <el-select v-model="detailed" placeholder="是否包含商品明细">
              <el-option label="含商品明细" :value="1"> </el-option>
              <el-option label="不含商品明细" :value="0"> </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row
          v-show="detailed == 0"
          type="flex"
          justify="center"
          align="middle"
          style="margin-bottom: 20px;"
        >
          <el-col :span="8"><div>是否合并数据</div></el-col>
          <el-col :span="12"
            ><el-radio v-model="isExpend" :label="1">是</el-radio
            ><el-radio v-model="isExpend" :label="0">否</el-radio></el-col
          >
        </el-row>
        <div v-show="detailed == 0">
          （当客户名称、客户电话、客户地址完全一致时）
        </div>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirm">导出</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import UploadExcelComponent from "@/components/common/UploadExcel/index.vue";
import {
  customExpressList,
  courierListStatus,
  orderCourierUpdate,
  saveNotSystemLogisticsByOrder
} from "@/models/ts";
import {
  getOrderList,
  getFactoryOrderList,
  getOrderGoodsDetail
} from "@/models/orderModel";
import { normalCourier } from "@/utils/enum.js";
const mergeArr = function(arr) {
  if (arr.length < 1) {
    return [];
  }
  var conut = [];
  for (let [index, item] of arr.entries()) {
    var sliceArr = arr.slice(index + 1);
    for (let [sub, i] of sliceArr.entries()) {
      if (
        item.user_name + item.mobile + item.address ===
        i.user_name + i.mobile + i.address
      ) {
        if (item.main_number && i.main_number) {
          item.main_number = item.main_number + "," + i.main_number;
        } else if (i.main_number) {
          item.main_number = i.main_number;
        }
        if (item.serial_number && i.serial_number) {
          item.serial_number = item.serial_number + "," + i.serial_number;
        } else if (i.serial_number) {
          item.serial_number = i.serial_number;
        }
        if (item.courier_number && i.courier_number) {
          item.courier_number = item.courier_number + "," + i.courier_number;
        } else if (i.courier_number) {
          item.courier_number = i.courier_number;
        }
        if (item.courier_mobile && i.courier_mobile) {
          item.courier_mobile = item.courier_mobile + "," + i.courier_mobile;
        } else if (i.courier_mobile) {
          item.courier_mobile = i.courier_mobile;
        }
        if (item.id && i.id) {
          item.id = item.id + "," + i.id;
        }
        conut.push(sub + index + 1);
      }
    }
  }
  conut = [...new Set(conut)].sort((a, b) => {
    return a - b;
  });
  var t = 0;
  for (let c of conut) {
    arr.splice(c - t, 1);
    t++;
  }
  for (let item of arr) {
    item.courier_number = item.courier_number.toString();
    item.courier_mobile = item.courier_mobile.toString();
    item.courier_number = [...new Set(item.courier_number.split(","))].join();
    item.courier_mobile = [...new Set(item.courier_mobile.split(","))].join();
  }
  return arr;
};
const expend = function(arr) {
  let expend = [];
  let indexs = [];
  for (let [index, item] of arr.entries()) {
    let mainNumbers = item.main_number.split(",");
    let serialNumbers = item.serial_number.split(",");
    let ids = item.id.split(",");
    if (mainNumbers.length > 1) {
      for (let [i, mergeItem] of mainNumbers.entries()) {
        let t = Object.assign({}, item);
        t.main_number = mergeItem;
        t.serial_number = serialNumbers[i];
        t.id = ids[i];
        expend.push(t);
      }
      indexs.push(index);
    }
  }
  indexs = [...new Set(indexs)].sort((a, b) => {
    return a - b;
  });
  let n = 0;
  for (let m of indexs) {
    arr.splice(m - n, 1);
    n++;
  }
  return [...arr, ...expend];
};
const iscontain = function(sourceArr, tagetArr) {
  let result = true;
  for (let item of tagetArr) {
    let flag = sourceArr.find(i => i === item);
    if (!flag) {
      result = false;
      break;
    }
  }
  return result;
};
const mergeImport = function(arr) {
  if (arr.length < 1) {
    return [];
  }
  var conut = [];
  for (let [index, item] of arr.entries()) {
    var sliceArr = arr.slice(index + 1);
    for (let [sub, i] of sliceArr.entries()) {
      if (item.id === i.id) {
        if (item.courier_number && i.courier_number) {
          item.courier_number = item.courier_number + "," + i.courier_number;
        } else if (i.courier_number) {
          item.courier_number = i.courier_number;
        }
        if (item.courier_mobile && i.courier_mobile) {
          item.courier_mobile = item.courier_mobile + "," + i.courier_mobile;
        } else if (i.courier_mobile) {
          item.courier_mobile = i.courier_mobile;
        }
        conut.push(sub + index + 1);
      }
    }
  }
  conut = [...new Set(conut)].sort((a, b) => {
    return a - b;
  });
  var t = 0;
  for (let c of conut) {
    arr.splice(c - t, 1);
    t++;
  }
  for (let item of arr) {
    item.courier_number = item.courier_number.toString();
    item.courier_mobile = item.courier_mobile.toString();
    item.courier_number = [...new Set(item.courier_number.split(","))].join();
    item.courier_mobile = [...new Set(item.courier_mobile.split(","))].join();
  }
  return arr;
};
export default {
  name: "",
  components: { UploadExcelComponent },
  data() {
    return {
      ts: "",
      tsList: [],
      tsListShort: normalCourier,
      orderIds: "", // 订单id
      loading: false,
      downloadLoading: false,
      tableData: [],
      failedRowIndex: [], // 错误行
      isFactory: false,
      isExpend: 0, // 是否合并数据
      dialogVisible: false,
      params: {}, // 数据查询条件
      detailed: 0
    };
  },
  watch: {},
  computed: {
    mainNumberCount() {
      return this.tableData.length;
    },
    boxNumberCount() {
      let count = 0;
      this.tableData.forEach(item => {
        if (typeof Number(item.box_num) === "number") {
          count += Number(item.box_num);
        }
      });
      return count;
    },
    tsNumberCount() {
      let count = 0;
      this.tableData.forEach(item => {
        if (item.courier_number) {
          let tsNumList = (item.courier_number + "").split(",");
          count += tsNumList.length;
        }
      });
      return count;
    }
  },
  methods: {
    // 物流承运商-筛选
    filterMethod(e) {
      let res = [];
      if (e && e.length > 0) {
        this.tsList.filter(item => {
          if (item.provider_name.indexOf(e) > -1) {
            res.push(item);
          }
        });
        this.$nextTick(() => {
          this.tsListShort = res;
        });
      } else {
        this.$nextTick(() => {
          this.tsListShort = normalCourier;
        });
      }
    },
    // 切换物流承运商
    handleChangeCourier(e, { $index }) {
      const data = this.tableData.slice(0);
      const name = this.getTsName(e);
      data[$index].courier_code = e;
      data[$index].courierName = name;
      this.$nextTick(() => {
        this.tableData = data;
      });
      const newShortTsList = normalCourier.slice(0);
      let flag = -1;
      normalCourier.map((item, index) => {
        if (item.provider_code === e) {
          flag = index;
        }
      });
      if (flag === -1) {
        newShortTsList.unshift({ provider_code: e, provider_name: name });
      } else {
        const firstArr = normalCourier[flag];
        newShortTsList.splice(flag, 1);
        newShortTsList.unshift(firstArr);
      }
      this.$nextTick(() => {
        this.tsListShort = newShortTsList;
      });
    },
    // 清除选项，重置为初始化下拉选项
    setTsListShort() {
      this.$nextTick(() => {
        this.tsListShort = normalCourier;
      });
    },
    tableRowClassName({ row, rowIndex }) {
      for (const i of this.failedRowIndex) {
        if (rowIndex === i) {
          return "error-row";
        }
      }
      return "";
    },
    // X关闭当前页
    closeCurrntPage() {
      // this.$router.push('/order/manage')
      if (localStorage.getItem("is_jgj") === "1") {
        // 为紧固件
        this.$router.push("/order/manageFastener");
      } else {
        this.$router.push("/order/manage");
      }
    },
    // 导入excel
    importExcel({ results, header }) {
      this.failedRowIndex = [];
      // 推送日期,主单号 编号 单号数 承运商编号 子单号
      console.log(results, header, "导入excel");
      // 不含商品
      let arr = [
        "ID",
        "主单号",
        "客户姓名",
        "客户电话",
        "客户地址",
        "编号",
        "物流承运商",
        "物流运单号",
        "物流联系电话"
      ];
      // 含商品
      let detailArr = [
        "ID",
        "主单号",
        "客户姓名",
        "客户电话",
        "客户地址",
        "编号",
        "子订单号",
        "商品名称",
        "实发数量",
        "物流承运商",
        "物流运单号",
        "物流联系电话"
      ];

      if (iscontain(header, detailArr)) {
        // 含商品明细导入
        let resultsList = results.map(item => {
          let obj = {
            main_number: item["主单号"] || "",
            user_name: item["客户姓名"] || "",
            mobile: item["客户电话"] || "",
            address: item["客户地址"] || "",
            serial_number: item["编号"] || "",
            order_number: item["子订单号"] || "",
            name: item["商品名称"],
            send_amount: item["实发数量"],
            courier_code: this.getTsCode(item["物流承运商"]) || "",
            courier_number: item["物流运单号"] || "",
            courier_mobile: item["物流联系电话"] || "",
            id: item["ID"] || ""
          };
          return obj;
        });
        let checkResult = true;
        resultsList.forEach(item => {
          item.courier_number = item.courier_number.toString();
          item.courier_number = item.courier_number
            ? item.courier_number.replace(/，|,|，|, /gi, ",")
            : "";
          item.courier_number = [
            ...new Set(item.courier_number.split(","))
          ].join();
          item.err_cause = "";
          if (item.courier_code === "") {
            checkResult = false;
            item.err_cause += "物流承运商不可为空！";
          } else {
            for (let point of resultsList) {
              if (
                point.id === item.id &&
                point.courier_code != "" &&
                point.courier_code != item.courier_code
              ) {
                checkResult = false;
                item.err_cause += "物流承运商不一致！";
                break;
              }
            }
          }
          if (item.courier_number === "" && item.courier_mobile === "") {
            checkResult = false;
            item.err_cause += "物流运单号与物流联系电话不可同时为空！";
          }
          if (item.courier_mobile !== "") {
            for (let point of resultsList) {
              if (
                point.id === item.id &&
                point.courier_mobile != "" &&
                point.courier_mobile != item.courier_mobile
              ) {
                checkResult = false;
                item.err_cause += "物流联系电话不一致！";
                break;
              }
            }
          }
          if (item.err_cause !== "") {
            item.err_cause = `${item.serial_number}:${item.err_cause}`;
          }
        });
        if (checkResult) {
          let listR = mergeImport(resultsList);
          this.tableData.forEach(item => {
            let order = listR.find(result => {
              return (
                item.main_number + "" + item.id ==
                result.main_number + "" + result.id
              );
            });
            if (order) {
              item.courier_code = order.courier_code;
              item.courier_number = order.courier_number;
              item.courier_mobile = order.courier_mobile;
              const name = this.getTsName(order.courier_code);
              item.courier_name = name;
              item.courierName = name;
            }
          });
          this.$message.success("导入成功！");
        } else {
          this.$confirm("导入数据有误，是否下载查看原因？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true
          }).then(() => {
            import("@/vendor/Export2Excel").then(excel => {
              let tHeader = [
                "ID",
                "主单号",
                "客户姓名",
                "客户电话",
                "客户地址",
                "编号",
                "子订单号",
                "商品名称",
                "实发数量",
                "物流承运商",
                "物流运单号",
                "物流联系电话",
                "错误原因"
              ];
              let filterVal = [
                "id",
                "main_number",
                "user_name",
                "mobile",
                "address",
                "serial_number",
                "order_number",
                "name",
                "send_amount",
                "courier_code",
                "courier_number",
                "courier_mobile",
                "err_cause"
              ];
              const data = this.formatJson(filterVal, resultsList);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename:
                  "填写物流信息错误原因" +
                  moment().format("YYYY-MM-DD HH:mm:ss"),
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          });
        }
      } else if (iscontain(header, arr)) {
        // 不含商品明细
        let resultsList = results.map(item => {
          let obj = {
            main_number: item["主单号"] || "",
            serial_number: item["编号"] || "",
            user_name: item["客户姓名"] || "",
            mobile: item["客户电话"] || "",
            address: item["客户地址"] || "",
            box_num: item["单号数"] || "",
            courier_code: this.getTsCode(item["物流承运商"]) || "",
            courier_number: item["物流运单号"] || "",
            courier_mobile: item["物流联系电话"] || "",
            id: item["ID"] || ""
          };
          return obj;
        });
        let checkResult = true;
        resultsList.forEach(item => {
          item.courier_number = item.courier_number.toString();
          item.courier_number = item.courier_number
            ? item.courier_number.replace(/，|,|，|, /gi, ",")
            : "";
          item.courier_number = [
            ...new Set(item.courier_number.split(","))
          ].join();
          item.err_cause = "";
          if (item.courier_code === "") {
            checkResult = false;
            item.err_cause += "物流承运商不可为空！";
          } else {
            for (let point of resultsList) {
              if (
                point.id === item.id &&
                point.courier_code != "" &&
                point.courier_code != item.courier_code
              ) {
                checkResult = false;
                item.err_cause += "物流承运商不一致！";
                break;
              }
            }
          }
          if (item.courier_number === "" && item.courier_mobile === "") {
            checkResult = false;
            item.err_cause += "物流运单号与物流联系电话不可同时为空！";
          }
          if (item.err_cause !== "") {
            item.err_cause = `${item.serial_number}:${item.err_cause}`;
          }
        });
        if (checkResult) {
          let listR = expend(resultsList);
          this.tableData.forEach((item, index) => {
            let order = listR.find(result => {
              return (
                item.main_number + "" + item.id ==
                result.main_number + "" + result.id
              );
            });
            if (order) {
              item.courier_code = order.courier_code;
              item.courier_number = order.courier_number;
              item.courier_mobile = order.courier_mobile;
              const name = this.getTsName(order.courier_code);
              item.courier_name = name;
              item.courierName = name;
            }
          });
          this.$message.success("导入成功！");
        } else {
          this.$confirm("导入数据有误，是否下载查看原因？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true
          }).then(() => {
            import("@/vendor/Export2Excel").then(excel => {
              let tHeader = [
                "ID",
                "主单号",
                "客户姓名",
                "客户电话",
                "客户地址",
                "编号",
                "物流承运商",
                "物流运单号",
                "物流联系电话",
                "错误原因"
              ];
              let filterVal = [
                "id",
                "main_number",
                "user_name",
                "mobile",
                "address",
                "serial_number",
                "courier_code",
                "courier_number",
                "courier_mobile",
                "err_cause"
              ];
              const data = this.formatJson(filterVal, resultsList);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename:
                  "填写物流信息错误原因" +
                  moment().format("YYYY-MM-DD HH:mm:ss"),
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          });
        }
      } else {
        this.$message.error("请检查表头是否正确");
      }
    },
    // 导出excel
    exportExcel() {
      this.formatData();
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then(async excel => {
        let tHeader = [];
        let filterVal = [];
        let list = JSON.parse(JSON.stringify(this.tableData));
        list.forEach(item => {
          if (item.serial_number && item.serial_number.split(",").length > 1) {
            let arr = item.serial_number.split(",");
            for (let i of arr) {
              if (i.serial_number && i.serial_number.split("-").length > 3) {
                i.serial_number = i.serial_number
                  ? i.serial_number
                      .split("-")
                      .slice(3)
                      .join("-")
                  : "";
              }
            }
            item.serial_number = arr.join(",");
          } else {
            if (
              item.serial_number &&
              item.serial_number.split("-").length > 3
            ) {
              item.serial_number = item.serial_number
                ? item.serial_number
                    .split("-")
                    .slice(3)
                    .join("-")
                : "";
            }
          }
        });

        if (this.detailed !== 1) {
          // 不含商品明细
          tHeader = [
            "ID",
            "主单号",
            "客户姓名",
            "客户电话",
            "客户地址",
            "编号",
            "物流承运商",
            "物流运单号",
            "物流联系电话"
          ];
          filterVal = [
            "id",
            "main_number",
            "user_name",
            "mobile",
            "address",
            "serial_number",
            "courier_code",
            "courier_number",
            "courier_mobile"
          ];
          // 合并
          if (this.isExpend === 1 && this.detailed !== 1) {
            list = mergeArr(list);
          }
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename:
              "订单-录入物流运单-普通（不含商品明细）" +
              moment().format("YYYY-MM-DD HH:mm:ss"),
            autoWidth: true,
            bookType: "xlsx"
          });
          this.downloadLoading = false;
        } else {
          // 含商品明细
          tHeader = [
            "ID",
            "主单号",
            "客户姓名",
            "客户电话",
            "客户地址",
            "编号",
            "子订单号",
            "商品名称",
            "实发数量",
            "物流承运商",
            "物流运单号",
            "物流联系电话"
          ];
          filterVal = [
            "id",
            "main_number",
            "user_name",
            "mobile",
            "address",
            "serial_number",
            "order_number",
            "name",
            "send_amount",
            "courier_code",
            "courier_number",
            "courier_mobile"
          ];
          let ids = list.map(item => item.id);
          let goodsListData =
            (await getOrderGoodsDetail({ ids: ids.join(), type: 1 })) || [];
          goodsListData.forEach(item => {
            let order = list.find(result => {
              return item.order_id === result.id;
            });
            return Object.assign(item, order);
          });
          let newGoodslist = [];
          list.forEach(item => {
            goodsListData.forEach(i => {
              if (item.id === i.order_id) {
                newGoodslist.push(i);
              }
            });
          });
          const data = this.formatJson(filterVal, newGoodslist);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename:
              "订单-录入物流运单-普通（含商品明细）" +
              moment().format("YYYY-MM-DD HH:mm:ss"),
            autoWidth: true,
            bookType: "xlsx"
          });
          this.downloadLoading = false;
        }
      });
    },
    getTsName(id) {
      let name = "";
      // console.log(this.tsList, 'this.tsList')
      this.tsList.forEach(item => {
        if (item.provider_code === id) {
          name = item.provider_name;
        }
      });
      return name;
    },
    getTsNameNormal(id) {
      let name = "";
      normalCourier.forEach(item => {
        if (item.provider_code === id) {
          name = item.provider_name;
        }
      });
      return name;
    },
    getTsCode(name) {
      let code = "";
      // console.log(this.tsList, 'this.tsList')
      this.tsList.forEach(item => {
        if (item.provider_name === name) {
          code = item.provider_code;
        }
      });
      return code;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "courier_code") {
            console.log(v[j], "ggggg");
            return this.getTsName(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    handleCommand(val) {
      console.log(val, "drop");
      // 导出
      if (val === "b") {
        this.dialogVisible = true;
      }
      // 导入
      if (val === "a") {
        this.$refs.uploadExcel.handleUpload();
      }
    },
    confirm() {
      // 合并
      if (this.isExpend === 1 && this.detailed !== 1) {
        let list = JSON.parse(JSON.stringify(this.tableData));
        let listMerge = true;
        for (let item of list) {
          for (let i of list) {
            if (
              item.user_name + item.mobile + item.address ===
              i.user_name + i.mobile + i.address
            ) {
              if (item.courier_code !== i.courier_code) {
                listMerge = false;
              }
            }
          }
          if (!listMerge) {
            break;
          }
        }
        if (!listMerge) {
          this.$confirm(
            "存在物流承运商不一致，若合并导出仅保留第一条物流承运商。是否继续合并导出？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              center: true
            }
          ).then(() => {
            this.exportExcel();
          });
        } else {
          this.exportExcel();
        }
      } else {
        this.exportExcel();
      }
      this.dialogVisible = false;
    },
    // 提交数据校验物流承运商是否为空  打包箱数是否和单号一致
    checkTableData() {
      let errorType = 1; // 错误类型 -1没有快递单号 -2快递单号与打包箱数不符  -3快递单号格式错误 -4承运商为空
      let failedRowIndexList = [];
      let reg = /^[A-Za-z0-9]+$/;
      this.tableData.forEach((item, index) => {
        let tsNumList = [];
        if (item.courier_number) {
          tsNumList = (item.courier_number + "").split(",");
        }
        if (!item.courier_code) {
          failedRowIndexList.push(index);
          errorType = -4;
        } else if (!item.courier_number) {
          failedRowIndexList.push(index);
          errorType = -1;
        } else if (tsNumList.length !== Number(item.box_num)) {
          if (!this.isFactory) {
            failedRowIndexList.push(index);
            errorType = -2;
          }
        } else {
          let every = tsNumList.every(item => {
            return reg.test(item);
          });
          if (!every) {
            failedRowIndexList.push(index);
            errorType = -3;
          }
        }
      });
      this.failedRowIndex = [...new Set(failedRowIndexList)];
      console.log(this.failedRowIndex, " this.failedRowIndex");
      return errorType;
    },
    // 逗号更换
    formatData() {
      this.tableData.forEach(item => {
        item.courier_number = item.courier_number
          ? item.courier_number.replace(/，|,|，|, /gi, ",")
          : "";
      });
    },
    // 提交更改
    saveHandler() {
      this.formatData();
      let errorType = this.checkTableData();
      if (errorType > 0) {
        let data = this.tableData.map(item => {
          if (!this.isFactory) {
            return {
              id: item.id,
              main_number: item.main_number,
              courier_number: item.courier_number,
              box_num: item.box_num,
              courier_name: this.getTsName(item.courier_code),
              courier_code: item.courierName,
              courier_mobile: item.courier_mobile
            };
          } else {
            return {
              id: item.id,
              main_number: item.main_number,
              courier_number: item.courier_number,
              courier_name: this.getTsName(item.courier_code),
              courier_code: item.courier_code,
              courier_mobile: item.courier_mobile
            };
          }
        });

        if (this.isFactory) {
          saveNotSystemLogisticsByOrder({
            items: JSON.stringify(data)
          });
        } else {
          orderCourierUpdate({
            item: JSON.stringify(data)
          });
        }
        if (!this.isFactory) {
          this.$message.success(
            "保存成功，请稍后查看物流单号更新状态（订单列表=>物流单号更新状态）"
          );
        } else {
          this.$message.success("保存成功");
        }
      } else {
        if (errorType === -1) {
          this.$message.error("单号为空,请填写后保存");
        }

        if (errorType === -2) {
          this.$message.error("打包箱数与单号个数不一致");
        }
        if (errorType === -3) {
          this.$message.error("单号格式错误");
        }
        if (errorType === -4) {
          this.$message.error("承运商为空,请选择后保存");
        }
      }
    },
    async getData() {
      this.loading = true;
      if (this.$route.params.isAll === "YES") {
        // “录入全部”，更新为录入当前页全部 - （2023/09/11更新）
        this.params = {
          // ids: this.orderIds,
          ids: "",
          page: 1,
          pagesize: 9999,
          instatus: this.$route.params.orderType,
          order_type: 0
        };
      } else {
        this.orderIds = JSON.parse(this.$route.params.ids);
        this.params = {
          ids: this.orderIds,
          page: 1,
          pagesize: 9999,
          instatus: this.$route.params.orderType,
          order_type: 0
        };
      }
      if (localStorage.getItem("shop_type") === "2") {
        this.isFactory = true;

        try {
          let tableData = await getFactoryOrderList(this.params);
          tableData.list.map(
            item =>
              (item.courierName =
                item.courier_name ||
                this.getTsNameNormal(item.courier_code) ||
                item.courier_code)
          );
          this.tableData = tableData.list || [];
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.$message.error(error.message);
        }
      } else {
        try {
          let tableData = await getFactoryOrderList(this.params);
          tableData.list.map(
            item =>
              (item.courierName =
                item.courier_name ||
                this.getTsNameNormal(item.courier_code) ||
                item.courier_code)
          );
          this.tableData = tableData.list || [];
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.$message.error(error.message);
        }
      }
    }
  },
  async created() {
    try {
      let tsList = await customExpressList({});
      if (tsList.code === 200) {
        this.tsList = tsList.data.succeed.map(item => {
          return {
            provider_code: item.logistics_code,
            provider_name: item.logistics_name
          };
        });
      }
    } catch (error) {}
    this.getData();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.closeCurrntPage {
  border-radius: 10px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
  font-size: 14px;
  position: fixed;
  right: 16px;
  line-height: 20px;
  top: 53px;
  text-align: center;
  width: 94px;
  height: 20px;
  border-radius: 5px;
  background-color: white;
}
.a-upload {
  padding: 9px 15px;
  // height: 20px;
  font-size: 12px;
  line-height: 1;
  position: relative;
  cursor: pointer;
  color: #606266;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: inline-block;
  *display: inline;
  *zoom: 1;
  vertical-align: middle;
}

.a-upload input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
}

.a-upload:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
  text-decoration: none;
}
.gap-top {
  margin-top: 10px;
}
.gap-bottom {
  margin-bottom: 10px;
}
.count-wrap {
  border-top: 1px solid #d6d0d0;
  margin-top: 20px;
  padding-left: 30px;
  div {
    margin-right: 30px;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/input-ts.vue